module.exports = __webpack_public_path__ + "img/14.413fe079.jpg";